import type * as React from 'react';

import { isHotkey } from 'is-hotkey';

import {
  type ButtonRole,
  TOOLBAR_BUTTON_TYPES,
  type ToolbarButtonType,
} from 'bundles/cml/editor/components/buttons/types';

export const isLeftKey = isHotkey('left', { byKey: true });
export const isRightKey = isHotkey('right', { byKey: true });

export const shouldFocusOnClick = (type: ToolbarButtonType) => {
  return type === TOOLBAR_BUTTON_TYPES.insertion || type === TOOLBAR_BUTTON_TYPES.formatting;
};

type Props = {
  title?: string;
  role: ButtonRole;
  type: ToolbarButtonType;
  active?: boolean;
};

export const getAriaAttributes = ({ title, role, type, active }: Props): React.AriaAttributes => {
  const ariaAttributes: React.AriaAttributes = {};

  if (title) {
    ariaAttributes['aria-label'] = title;
  }

  if (role === 'button' && type !== TOOLBAR_BUTTON_TYPES.menu) {
    ariaAttributes['aria-pressed'] = active;
  }

  if (type === TOOLBAR_BUTTON_TYPES.menu) {
    ariaAttributes['aria-expanded'] = active;
    ariaAttributes['aria-haspopup'] = 'menu';
  }

  return ariaAttributes;
};
